import React from 'react'
import Navbar from 'components/Navbar'
import { CorpoConteudo } from 'layouts/simple/style'
import SejaParceiroComponent from './components/SejaParceiro'
import Filosofia from './components/Filosofia'

const SejaParceiro = () => {
  return (
    <>
      <Navbar />
      <CorpoConteudo minHeight="calc(100vh - 60px)">
        <Filosofia />
        <SejaParceiroComponent />
      </CorpoConteudo>
    </>
  )
}

export default SejaParceiro
